"use strict";
/*!
 *
 *  extend-link.js
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var default_1 = /** @class */ (function () {
    // $elem: JQuery;
    function default_1(elem) {
        // this.$elem = $(elem);
        var link = 'a[href^="#"]:not([href="#"]), a[href^="' + location.pathname + '#"], a[href^="' + location.protocol + '//' + location.hostname + location.pathname + '#"]';
        $(document).delegate(elem, 'click', function (e) {
            var $a = $(e.currentTarget).find('a');
            var href = $a.attr('href');
            if ($a.is(link)) {
                e.preventDefault();
                if (href !== undefined) {
                    href = href.replace(location.protocol + '//' + location.hostname + location.pathname, '').replace(location.pathname, '');
                    var offset = $(href).offset();
                    var top_1 = offset !== undefined ? offset.top : 0;
                    console.log(util.scrollGap);
                    $(util.scroller).animate({
                        scrollTop: top_1 - util.scrollGap
                    }, {
                        duration: 700,
                        easing: 'easeOutExpo',
                        queue: false
                    });
                }
                ;
            }
            else {
                var target = $a.attr('target') !== undefined ? $a.attr('target') : '_self';
                window.open(href, target);
            }
            ;
        });
    }
    return default_1;
}());
exports.default = default_1;
